const app = {
  state: {
    navTitle: '',
    showNavRightBtn: false,
    showNavSetting: false,
    showNavLeftRegBtn: false,
    showNavBack: true,
    headerShowBottomArrow: false,
    navRightBtnHtml: '',
    bodyPaddingBottom: '0.2rem',
    leftBackTxt: '返回',
    isShowHeader: true,
    showNavRightLoginBox: true,
    isMobile: false,
    lang: 'zh-CN',
    rotateVal: false,
    autoHeight: true,
  },
  mutations: {
    SET_AUROHEIGHT: (state, val) => {
      state.autoHeight = val;
    },
    SET_NAV_TITLE: (state, title) => {
      state.navTitle = title;
    },
    SET_SHOW_NAV_BOTTOM_ARROW: (state, isShow) => {
      state.headerShowBottomArrow = isShow;
    },
    SET_NAV_RIGHT_BTN: (state, arg) => {
      state.showNavRightBtn = arg.showOrHide || false;
      state.navRightBtnHtml = arg.html || '';
    },
    SET_SHOW_NAV_BACK: (state, arg) => {
      state.showNavBack = arg.showOrHide || false;
      state.leftBackTxt = arg.txt || '返回';
    },
    RESET_NAV_BACK: (state) => {
      state.showNavBack = true
      state.leftBackTxt = '返回'
    },
    SET_SHOW_NAV_SETTING: (state, showOrHide) => {
      state.showNavSetting = showOrHide;
    },
    SET_BODY_PADDING_BOTTOM: (state, h) => {
      state.bodyPaddingBottom = h;
    },
    RESET_BODY_PADDING_BOTTOM: (state) => {
      state.bodyPaddingBottom = '0.2rem';
    },
    SET_SHOW_NAV_LEFT_REG_BTN: (state, showOrHide) => {
      state.showNavLeftRegBtn = showOrHide || false;
    },
    SET_SHOW_HEADER: (state, showOrHide) => {
      state.isShowHeader = showOrHide
    },
    SHOW_NAV_RIGHT_BTN: (state, showOrHide) => {
      state.showNavRightLoginBox = showOrHide
    },
    SET_MOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_LANG: (state, lang) => {
      state.lang = lang
    },
    SET_ROTATE: (state, bool) => {
      state.rotateVal = bool
    }
  },
  actions: {
    setBodyPaddingBottom({
      commit
    }, h) {
      commit('SET_BODY_PADDING_BOTTOM', h);
    },
    resetBodyPaddingBottom({
      commit
    }) {
      commit('RESET_BODY_PADDING_BOTTOM');
    },
    setNavTitle({
      commit
    }, title) {
      document.title = title;
      commit('SET_NAV_TITLE', title);
    },
    setNavRightBtn({
      commit
    }, arg) {
      commit('SET_NAV_RIGHT_BTN', arg);
    },
    setNavBack({
      commit
    }, arg) {
      commit('SET_SHOW_NAV_BACK', arg);
    },
    resetNavBack({
      commit
    }) {
      commit('RESET_NAV_BACK');
    },
    setNavSetting({
      commit
    }, arg) {
      commit('SET_SHOW_NAV_SETTING', arg);
    },
    setNavBottomArrow({
      commit
    }, arg) {
      commit('SET_SHOW_NAV_BOTTOM_ARROW', arg);
    },
    showNavLeftRegBtn({
      commit
    }, arg) {
      commit('SET_SHOW_NAV_LEFT_REG_BTN', arg)
    },
    showHeader({
      commit
    }, arg) {
      commit('SET_SHOW_HEADER', arg)
    },
    setShowRightLoginBox({
      commit
    }, arg) {
      commit('SHOW_NAV_RIGHT_BTN', arg)
    },
    setMobile({
      commit
    }, arg) {
      commit('SET_MOBILE', arg)
    },
    setLang({
      commit
    }, arg) {
      commit('SET_LANG', arg)
    },
    setRotate(
      {
        commit
      }, arg
    ) {
      commit('SET_ROTATE', arg)
    },
    setAutoHeight(
      {
        commit
      }, arg
    ) {
      commit('SET_AUROHEIGHT', arg)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js